let animationTracingSuppressed = false;

export function setTelemetryAnimationActive(isActive: boolean): void {
  animationTracingSuppressed = isActive;
}

export function isTelemetryAnimationActive(): boolean {
  return animationTracingSuppressed;
}
